import { render, staticRenderFns } from "./Galeri.vue?vue&type=template&id=7c9e8071&scoped=true&"
import script from "./Galeri.vue?vue&type=script&lang=js&"
export * from "./Galeri.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c9e8071",
  null
  
)

export default component.exports